import React, { FC } from 'react';
import { Grid } from '@material-ui/core';

import { UserFeedFollowGroupFragment } from 'api';
import { GroupAvatar } from 'components';

interface IProps {
  group: UserFeedFollowGroupFragment;
}

const ImageCell: FC<IProps> = ({ group }) => (
  <Grid item>
    <GroupAvatar link group={group} size={80} square />
  </Grid>
);

export default ImageCell;
